const positiveId = (value: unknown): value is number =>
    typeof value === "number" && Number.isSafeInteger(value) && value > 0;

export const assessmentTaskSessionIdentity = (user: unknown): string | null => {
    if (!user || typeof user !== "object" || Array.isArray(user)) return null;
    const record = user as Record<string, unknown>;
    const userId = Number(record["user_id"] ?? record["userId"] ?? record["id"]);
    const accountId = Number(record["account_id"] ?? record["accountId"]);
    const role = typeof record["role"] === "string" ? record["role"]
        : typeof record["user_role"] === "string" ? record["user_role"] : "";
    const sessionId = record["session_id"] ?? record["sessionId"];
    return positiveId(userId) && positiveId(accountId)
        ? JSON.stringify([accountId, userId, role, typeof sessionId === "string" ? sessionId : null])
        : null;
};
